export default __webpack_public_path__ + "static/media/easy-button-press.d06a1541.gif";